import Experience from "./Experience";
import ScrollArrow from "./UI/ScrollArrow";
import UploadModal from "./UI/UploadModal";

const canvas = document.querySelector("canvas.webgl") as HTMLElement;
const sectionsRoot = document.querySelector("#sections") as HTMLElement;

const experience = new Experience(canvas, sectionsRoot);

// Initialize scroll arrow
const scrollArrow = new ScrollArrow();

// Store scrollArrow reference in experience for space mode integration
(experience as any).scrollArrow = scrollArrow;

// Initialize upload modal with success callback
const uploadModal = new UploadModal((imageData) => {
  // On successful upload:
  // 1. Align earth to the new image location
  // 2. Refetch data to show the new pin
  // 3. Open the preview modal

  if (experience.world?.sceneDirector) {
    const earth = experience.world.sceneDirector.getEarth();

    if (earth) {
      // Align to coordinates (no zoom change)
      earth.alignToCoordinates(imageData.latitude, imageData.longitude);

      // Wait a bit for animation, then refresh and show
      setTimeout(() => {
        earth.refreshAndShowImage(imageData.id);
      }, 2000);
    }
  }
});

// Wire up the floating action button
const uploadFab = document.querySelector("#upload-fab");
if (uploadFab) {
  uploadFab.addEventListener("click", () => {
    uploadModal.open();
  });
}
